var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: _vm.filesUploadApi + "?name=test",
        multiple: "",
        headers: _vm.headers,
        "on-success": _vm.handleSuccess,
        "auto-upload": true,
        "file-list": _vm.fileList,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.handleBeforeUpload,
        limit: 1,
      },
    },
    [
      _vm.showVideoPath == ""
        ? _c(
            "div",
            { staticClass: "feed_upload" },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("点击上传"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showVideoPath != ""
        ? _c(
            "video",
            {
              staticClass: "video-js",
              staticStyle: { width: "50%" },
              attrs: { src: _vm.VideoPath, controls: "" },
            },
            [_vm._v("\n      您的浏览器不支持视频播放\n    ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }